import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var DocumentsIcon = createIcon({
  displayName: 'DocumentsIcon',
  path: /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 3a1 1 0 011-1h10a1 1 0 011 1v1.622A3 3 0 0014.172 4H9a3 3 0 00-3 3v11H5a1 1 0 01-1-1V3zm2 17H5a3 3 0 01-3-3V3a3 3 0 013-3h10a3 3 0 013 3v3.586l3.121 3.121A3 3 0 0122 11.828V21a3 3 0 01-3 3H9a3 3 0 01-3-3v-1zM9 6a1 1 0 00-1 1v14a1 1 0 001 1h10a1 1 0 001-1v-9h-3a3 3 0 01-3-3V6H9zm7 1.414L18.586 10H17a1 1 0 01-1-1V7.415z",
    fill: "currentColor",
    fillRule: "evenodd"
  })
});
//# sourceMappingURL=Documents.js.map